import Route from '@ember/routing/route';

export default class LedgerItemsRoute extends Route {}
